"use strict";

angular.module("portal.lookup").controller("ServiceLookupDetail", [
    "$q",
    "$scope",
    "Cache",
    "$state",
    "$stateParams",
    "$rootScope",
    "$timeout",
    "Enterprise",
    "EnterprisePublicLookup",
    "Format",
    "Services",
    "Users",
    "Vehicles",
    function(
        $q,
        $scope,
        Cache,
        $state,
        $stateParams,
        $rootScope,
        $timeout,
        Enterprise,
        EnterprisePublicLookup,
        Format,
        Services,
        Users,
        Vehicles
    ) {
        $scope.loading = true;
        $scope.looking_up = false;
        $scope.promises = [];

        $scope.license_label = "License";

        $scope.detail_columns = [];
        $scope.result_columns_vehicles = [];
        $scope.vehicle_columns = [];
        $scope.result_columns_service_users = [];
        $scope.service_user_columns = [];
        $scope.certification_columns = [];
        $scope.cert_attribute_columns = [];
        $scope.service = $stateParams.service;

        if ($stateParams.lookup_object) {
            $scope.old_lookup_object = $stateParams.lookup_object;
        }

        if ($stateParams.priorState) {
            $scope.priorState = $stateParams.priorState;
        }

        // Make sure we have the enterprise details
        if ($rootScope.enterprise != null) {
            $scope.enterprise = $rootScope.enterprise;
            $scope.loading = false;
        } else {
            Enterprise.get($scope.parameters).then(function(result) {
                $scope.enterprise = result;
                $scope.loading = false;
            });
        }

        // Get the entity labels
        $scope.serviceLabel = $scope.enterprise.serviceLabels["SERVICE"];
        $scope.userLabel = $scope.enterprise.userLabels["USER"];

        if (!$scope.lookup_object) {
            $scope.lookup_object = {
                serviceID:
                    ($scope.old_lookup_object &&
                        $scope.old_lookup_object.serviceID) ||
                    $stateParams.id,
                enterprise_id: $rootScope.enterpriseID,
                records_offset: 0,
                records_total: 1,
                sort_fields: null,
                sort_direction: " asc",
                from_search: true
            };
        }

        // Get the service lookup detail columns, then check passed in service for existing columns
        EnterprisePublicLookup.get({
            enterpriseId: $rootScope.enterpriseID,
            code: "result",
            entity_type: "service"
        }).then(function(result) {
            if (result != null) {
                $scope.result_columns = result.filter(function(c) {
                    return c.category !== "certification";
                });

                // remove application and complaint columns from main list
                $scope.result_columns = $scope.result_columns.filter(function(
                    c
                ) {
                    return c.singular_relationship;
                });
                $scope.result_columns_certifications = result.filter(function (c) {
                    return (
                        !c.singular_relationship && c.category == "Certification List"
                    );
                });

                $scope.result_columns_certifications.forEach(function (column) {
                    // create columns for list directive
                    $scope.certification_columns.push({
                        label: column.label,
                        field: column.alias,
                        type: column.format_type,
                        revertTimeZone:
                            column.format_type == "date"
                                ? column.field.toLowerCase() == "issue_date" ||
                                    column.field.toLowerCase() ==
                                    "expiration_date" ||
                                    column.field.toLowerCase() ==
                                    "initial_issue_date"
                                    ? true
                                    : false
                                : undefined
                    });
                });

                // create columns for list directive
                $scope.cert_attribute_columns.push({
                    label: "Attribute Name",
                    field: "name",
                    type: "string"
                });

                // create columns for list directive
                $scope.cert_attribute_columns.push({
                    label: "Attribute Value",
                    field: "value",
                    type: "string"
                });

                $scope.result_columns_vehicles = result.filter(function(c) {
                    return (
                        !c.singular_relationship && c.table_name == "vehicles"
                    );
                });

                $scope.result_columns_vehicles.forEach(function(c) {
                    $scope.vehicle_columns.push({
                        label: c.label,
                        field: c.alias,
                        type: c.format_type
                    });
                });

                $scope.result_columns_service_users = result.filter(function(
                    c
                ) {
                    return (
                        !c.singular_relationship &&
                        c.table_name == "service_users"
                    );
                });

                $scope.result_columns_service_users.forEach(function(c) {
                    $scope.service_user_columns.push({
                        label: c.label,
                        field: c.alias,
                        type: c.format_type,
                        link:
                            c.field == "full_name"
                                ? {
                                      // conditionally add link property
                                      state: "portal.menus.userlookupdetail",
                                      params: [
                                          {
                                              name: "id",
                                              field: "id"
                                          },
                                          {
                                              name: "priorState",
                                              field: "priorState" // these are annoying
                                          },
                                          {
                                              name: "lookup_object",
                                              field: "lookup_object"
                                          }
                                      ]
                                  }
                                : undefined,
                        revertTimeZone:
                            c.format_type == "date"
                                ? c.field.toLowerCase() == "issue_date" ||
                                  c.field.toLowerCase() == "expiration_date"
                                    ? true
                                    : false
                                : undefined
                    });
                });

                getService().then(function(result) {
                    $scope.service = result;

                    if ($scope.service) {
                        if ($scope.service.website) {
                            $scope.service.websiteUrl = Format.url(
                                $scope.service.website
                            );
                        }

                        if ($scope.service.alert_count > 0) {
                            Services.getServiceAlerts({
                                serviceID: $scope.service.id,
                                is_public: true
                            }).then(function(result) {
                                $scope.service.alerts = result;
                                if (
                                    $scope.service.alerts != null &&
                                    $scope.service.alerts.length > 0
                                ) {
                                    $scope.service.alerts_concat = "";
                                    $scope.service.alerts.forEach(function(
                                        alert
                                    ) {
                                        // slightly faster than using .reduce
                                        $scope.service.alerts_concat +=
                                            ", " + alert.message;
                                    });
                                }
                            });
                        }

                        if (
                            $scope.result_columns_vehicles.length > 0 &&
                            !$scope.service.vehicles
                        ) {
                            $scope.service.service_vehicles_list_loading = true;
                            Vehicles.get({
                                service_id: $scope.service.id,
                                for_lookup: true,
                                enterpriseID: $rootScope.enterpriseID
                            }).then(function(result) {
                                if (result != null) {
                                    $scope.service.vehicles = result;
                                }
                                $scope.service.service_vehicles_list_loading = false;
                            });
                        }

                        if (
                            $scope.result_columns_certifications.length > 0 &&
                            !$scope.service.certifications
                        ) {
                            $scope.service.certifications_list_loading = true;
                            Services.getServiceCertifications(
                                $scope.service.id,
                                false,
                                $rootScope.enterpriseID
                            ).then(function (result) {
                                $scope.service.certifications = result;
                                $scope.service.certifications_list_loading = false;
                            });
                        }

                        $scope.service.priorState = $state.current.name;
                        if (
                            $scope.result_columns_service_users.length > 0 &&
                            $scope.service &&
                            !$scope.service.service_users
                        ) {
                            $scope.service.service_users_list_loading = true;
                            Users.getPublicSearchUser({
                                externalOnly: false,
                                service_id: $scope.service.id,
                                forService: true,
                                inactiveServiceUsers: true,
                                forServiceLookup: true,
                                enterpriseID: $rootScope.enterpriseID
                            }).then(function (result) {
                                $scope.service.service_users = result.map(
                                    function(user) {
                                        user.priorState = $state.current.name;
                                        user.lookup_object =
                                            $scope.lookup_object;
                                        return user;
                                    }
                                );
                                $scope.service.service_users_list_loading = false;
                            });
                        }
                    }
                });
            }
        });

        function getService() {
            var d = $q.defer();

            if (!$stateParams.service) {
                if (!$scope.lookup_object.serviceID) {
                    $scope.lookup_object.serviceID = $stateParams.id; // use the id if no service
                }
                Services.PublicLookupService($scope.lookup_object).then(function(
                    result
                ) {
                    var service = result && result.pop();
                    d.resolve(service);
                });
            } else {
                d.resolve($stateParams.service); // just return the service we got in state params
            }

            return d.promise;
        }
    }
]);
